"use strict";

export default {
  telefonnr1: "255ee9e6-e26a-7544-e053-0fd5a8c09460",
  telefonnr2: "255ee9e6-e270-7544-e053-0fd5a8c09460",
  fax: "255ee9e6-e26b-7544-e053-0fd5a8c09460",
  url: "255ee9e6-e26d-7544-e053-0fd5a8c09460"
};
